export type IsModuleAccessibleFn = (moduleKey: any) => boolean;

/**
 * function to decide whether "no indicator" should be shown.
 */
export function noIndicatorSelected(
    qciResultsDto: any,
    hnnResultsDto: any,
    csrdResultsDto: any,
    wlcResultsDto: any,
    isModuleAccessible: IsModuleAccessibleFn,
    modulesEnum: any
): boolean {
    const qciHidden = qciResultsDto == undefined || (qciResultsDto !== undefined && !isModuleAccessible(modulesEnum.Gwp));
    const hnnHidden = hnnResultsDto == undefined || (hnnResultsDto !== undefined && !isModuleAccessible(modulesEnum.Hnn));
    const csrdHidden = csrdResultsDto == undefined;
    const wlcHidden = wlcResultsDto == undefined || (wlcResultsDto !== undefined && !isModuleAccessible(modulesEnum.Gwp));

    return qciHidden && hnnHidden && csrdHidden && wlcHidden;
}